<ng-container>
  <section class="header-dialog-title">
    <span class="title"
      ><h1 mat-dialog-title>{{ data.title | translate }}</h1></span
    >
    <span class="close-btn" (click)="onCancle()">&times;</span>
  </section>
  <section class="body-dialog-content">
    @if (data.showData) {
      <div mat-dialog-content>
        <p>{{ data.message | translate }}</p>
      </div>
    }
    @if (additionalData.showAboutInfo) {
      <div class="about-dialog-container">
        <p class="about-row">
          <span class="about-label">{{ additionalData.aboutVersionLabel | translate }}</span>
          <span class="about-value">{{ additionalData.aboutVersion | translate }}</span>
        </p>
        <p class="about-row">
          <span class="about-label">{{ additionalData.aboutUpdatedLabel | translate }}</span>
          <span class="about-value">{{ additionalData.aboutUpdatedDate | translate }}</span>
        </p>
        <p class="about-row">
          <span class="about-label">{{ additionalData.aboutSupportLabel | translate }}</span>
          <span class="about-value about-support-email">{{ additionalData.aboutSupportEmail | translate }}</span>
        </p>
      </div>
    }
    @if (additionalData.showAdditionalMessage) {
      <div [class]="additionalData.userdetailscontainercss || ''">
        <p [class]="additionalData.confirmationtitlecss">
          {{ additionalData.additionalMessageConfirmationText | translate }}
        </p>
        <!-- Username -->
        <p [class]="additionalData.usernamecss">
          {{ additionalData.additionalMessageUserName | translate }}
        </p>

        
        
          <!-- User Title -->
          <p [class]="additionalData.usertitlecss">
            {{ additionalData.additionalMessageUserTitle | translate}}
          </p>

        <!-- User Email -->
        <p [class]="additionalData.useremailcss">
          {{ additionalData.additionalMessageUserEmail | translate }}
        </p>

        <!-- Note Details (often longer text) -->
        <div class="notes-container">
          <h3 [class]="additionalData.usernotecss">
            {{ additionalData.additionalMessageNote | translate }}
          </h3>
          <!-- User Email -->
          <p [class]="additionalData.notesuffixcss">
            {{ additionalData.additionalMessageExtras | translate }}
          </p>
          <p [class]="additionalData.notesectioncss">
            {{ additionalData.additionalMessageUserName }}
          </p>
          <p [class]="additionalData.notedetailscss">
            {{ additionalData.additionalMessageNoteDetails | translate }}
          </p>
        </div>
      </div>
    }
  </section>
  @if (additionalData.showFooter !== false) {
    <section class="footer-dialog-button">
      <mat-dialog-actions align="end">
        <button matButton mat-dialog-close (click)="onCancle()">
          {{ additionalData.cancelButtonText | translate }}
        </button>
        <button mat-raised-button color="primary" class="raised-btn" (click)="onConfirm()">
          {{ additionalData.confirmButtonText | translate }}
        </button>
      </mat-dialog-actions>
    </section>
  }
</ng-container>
